import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {
  messagesWarning: string[] = [];
  messagesSuccess: string[] = [];
  

  addWarning(message: string) {
    this.messagesWarning.push(message);
    setTimeout(()=>{ this.messagesSuccess = [] }, 4000)
  }


  addSuccess(message: string) {
    this.messagesSuccess.push(message);
    setTimeout(()=>{ this.messagesSuccess = [] }, 4000)
  }

  clearWarning() {
    this.messagesWarning = [];
  }

  clearSuccess() {
    this.messagesSuccess = [];
  }
}




// WEBPACK FOOTER //
// /app/src/app/services/message.service.ts